/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_G6_TInputs */

const en_mk_sec_pg_g6_t = /** @type {(inputs: Mk_Sec_Pg_G6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No unbounded agent-to-agent calls`)
};

const id_mk_sec_pg_g6_t = /** @type {(inputs: Mk_Sec_Pg_G6_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada agen memanggil agen tanpa batas`)
};

/**
* | output |
* | --- |
* | "No unbounded agent-to-agent calls" |
*
* @param {Mk_Sec_Pg_G6_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_g6_t = /** @type {((inputs?: Mk_Sec_Pg_G6_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_G6_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_g6_t(inputs)
	return en_mk_sec_pg_g6_t(inputs)
});